<script setup lang="ts">

</script>

<template>
  <section class="loading">
    <div class="spinner-border text-secondary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </section>
</template>